export const environment = {
    env: 'DEV',
    production: false,
    serverBaseUrl: 'https://api-dev.preplan.peacefulpetslogin.com',
    serverUrl: 'https://api-dev.preplan.peacefulpetslogin.com'
};
